<template>
<h1>Hello World: msg: {{display_message}}</h1>
</template>

<script>
    export default {
        name: "HelloWorld",
        props:['msg'],
        data(){
            return {
                display_message: ''
            }
        },
        mounted() {
            this.display_message = this.msg || '';
        }
    }
</script>

<style scoped>

</style>
